import { lazy } from 'react'

export const PaymentVariant2 = lazy(() => import('./PaymentVariant2'))
